import { render, staticRenderFns } from "./PingShenUser.vue?vue&type=template&id=d48d8112&scoped=true"
import script from "./PingShenUser.vue?vue&type=script&lang=js"
export * from "./PingShenUser.vue?vue&type=script&lang=js"
import style0 from "./PingShenUser.vue?vue&type=style&index=0&id=d48d8112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48d8112",
  null
  
)

export default component.exports